
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FAQKeyword from './FAQKeyword';
import Testimonials from './TestimonialKeyword';

function Innovacabforcorporateoffice() {



    const cardData =
    {
        keyword: 'Innova Cab for Corporate Office Services',
        heading: 'S9 Travels: Innova Cab for Corporate Office Services',
        headingDescription: 'S9 Travels offers premium and reliable Innova taxi services for corporate office transfers. Whether you need a comfortable ride for business meetings, corporate events, or airport transfers, our well-maintained fleet of Innovas ensures you travel in style and comfort. We understand the importance of punctuality and professionalism, making us your ideal partner for corporate travel.',

        top: 'Top Features of S9 Travels for Your Corporate Office Innova Cab',

"topPlaces": [
    {
      "title": "Gateway of India",
      "description": "The Gateway of India is an iconic symbol of Mumbai. This majestic archway was built to commemorate the visit of King George V and Queen Mary in 1911. Located on the waterfront, it’s a perfect spot for photography and to take in the beautiful views of the Arabian Sea."
    },
    {
      "title": "Marine Drive",
      "description": "Marine Drive, also known as the Queen's Necklace, is a stunning boulevard that stretches along the coastline. It’s famous for its beautiful sunset views and is a popular place for an evening stroll, offering a great vantage point of the city's skyline."
    },
    {
      "title": "Chhatrapati Shivaji Maharaj Terminus (CST)",
      "description": "This UNESCO World Heritage Site is one of Mumbai's most famous landmarks. Known for its Victorian Gothic architectural style, CST is a historic railway station and a must-visit for history and architecture enthusiasts."
    },
    {
      "title": "Elephanta Caves",
      "description": "A short ferry ride from the city takes you to Elephanta Island, where you can explore ancient rock-cut caves with stunning sculptures dedicated to Lord Shiva. The caves are a UNESCO World Heritage Site and offer a blend of art, history, and natural beauty."
    },
    {
      "title": "Colaba Causeway",
      "description": "Colaba Causeway is a vibrant shopping street where you can find everything from clothes, jewelry, and antiques to local handicrafts. It’s also home to a range of cafes and restaurants, making it a popular spot for tourists and locals alike."
    },
    {
      "title": "Bandra-Worli Sea Link",
      "description": "This stunning bridge is an engineering marvel and offers panoramic views of the Arabian Sea and Mumbai’s skyline. A drive across the Bandra-Worli Sea Link is an unforgettable experience, especially during the evening when the bridge is beautifully lit."
    },
    {
      "title": "Juhu Beach",
      "description": "Juhu Beach is one of Mumbai’s most famous beaches, popular for its relaxed atmosphere, food stalls, and lively crowds. It’s the perfect spot to enjoy a beach day, watch the sunset, or savor local street food like pav bhaji and bhel puri."
    },
    {
      "title": "Haji Ali Dargah",
      "description": "The Haji Ali Dargah is a beautiful mosque and tomb located on an islet in the Arabian Sea. This iconic structure is both a spiritual and architectural marvel, offering a serene and peaceful experience for visitors."
    },
    {
      "title": "Sanjay Gandhi National Park",
      "description": "Escape the hustle and bustle of Mumbai and visit Sanjay Gandhi National Park, located on the outskirts of the city. The park offers a green oasis with walking trails, a lake, and the famous Kanheri Caves, providing an ideal retreat for nature lovers."
    },
    {
      "title": "Chor Bazaar",
      "description": "Known as the 'Thieves Market,' Chor Bazaar is a bustling street market in the heart of Mumbai. It’s the place to go if you’re looking for vintage items, antiques, or unique collectibles at bargain prices."
    }
],

"services": [
    {
      "name": "Innova Cabs for Corporate Travel in Pune",
      "description": "Traveling for business? Choose our Innova cabs for corporate travel in Pune to ensure comfort, reliability, and professionalism. Whether you're heading to a meeting, office, or corporate event, our Innova taxis offer ample space for both passengers and luggage, making them ideal for business needs."
    },
    {
      "name": "Corporate Innova Taxi Booking Pune",
      "description": "Book a Corporate Innova taxi for your next business trip in Pune. Our service is specifically designed for corporate clients who need prompt, comfortable, and efficient transportation. The Innova taxis are perfect for handling both local travel and long-distance business journeys."
    },
    {
      "name": "Innova Cab for Office Commute in Pune",
      "description": "For daily office commutes in Pune, choose an Innova cab for a comfortable and stress-free ride. Whether you need a pick-up and drop-off service or a daily cab hire, our Innova cabs ensure punctuality and a high standard of comfort for corporate employees."
    },
    {
      "name": "Book Innova for Corporate Events in Pune",
      "description": "Planning a corporate event? Book an Innova cab to transport guests, speakers, and employees to your corporate event in Pune. Our Innova taxis offer luxury and comfort for group travel, making sure your team arrives in style and on time."
    },
    {
      "name": "Pune Corporate Innova Car Hire",
      "description": "Need a vehicle for your corporate travel needs? Hire an Innova car for your next business trip in Pune. Our well-maintained vehicles and professional drivers ensure that your business journey is smooth, timely, and comfortable."
    },
    {
      "name": "Pune to Office Innova Cab",
      "description": "Book an Innova cab for your office commute in Pune. Our reliable service will ensure timely pick-ups and drops, allowing your employees to focus on their work while we take care of the travel logistics."
    },
    {
      "name": "Affordable Corporate Innova Service",
      "description": "For businesses looking for an affordable corporate travel solution, our Innova cabs provide a budget-friendly option without compromising on quality. Enjoy cost-effective rates for group travel, daily commutes, or corporate event transportation."
    },
    {
      "name": "Corporate Car Hire Pune",
      "description": "For flexible and customized corporate travel options in Pune, choose our corporate car hire service. We offer a wide range of Innova cabs for hire to suit your specific business needs, from single-day hires to long-term contracts."
    },
    {
      "name": "Corporate Business Travel with Innova",
      "description": "Book an Innova cab for all your corporate business travel needs. Whether it's a trip to a business meeting, conference, or an airport transfer, our Innova taxis provide the perfect blend of luxury, comfort, and space for professional travel."
    },
    {
      "name": "Innova Cabs for Business Meetings",
      "description": "Arriving at an important business meeting? Make a good impression by booking an Innova cab to ensure you arrive in style and on time. Our comfortable and clean Innova cabs are ideal for professionals looking to make the best impression."
    },
    {
      "name": "Innova for Corporate Group Travel",
      "description": "Traveling with a team? Our Innova cabs are ideal for corporate group travel in Pune. Whether it's a team-building activity, corporate retreat, or inter-office travel, our spacious cabs can comfortably accommodate multiple passengers with plenty of room for luggage."
    },
    {
      "name": "Pune to Corporate Event by Innova",
      "description": "For corporate events in and around Pune, book an Innova cab for a smooth, luxurious journey. We offer both one-way and round-trip services, ensuring your team and guests reach the event location comfortably and on time."
    },
    {
      "name": "Book Corporate Innova for Executive Travel",
      "description": "For top-level executive travel, book an Innova cab with us. Our luxury Innova taxis offer privacy, comfort, and convenience for senior executives traveling to business meetings, conferences, or other corporate events."
    },
    {
      "name": "Luxury Corporate Travel in Innova",
      "description": "Treat your clients or executives to luxury corporate travel with our premium Innova cabs. These cabs come equipped with plush seating, air-conditioning, and a spacious interior, making them perfect for long corporate trips, meetings, or airport transfers."
    },
    {
      "name": "Corporate Travel Package Innova Pune",
      "description": "For businesses planning frequent travel, our corporate travel packages provide customized solutions that meet the unique needs of your company. Our Innova taxis offer a comfortable and convenient way to transport employees, clients, and executives across Pune or beyond."
    }
  ],

"tableData": [
  ["Innova Cabs for Corporate Travel in Pune", "Corporate Innova Taxi Booking Pune"],
  ["Innova Cab for Office Commute in Pune", "Book Innova for Corporate Events in Pune"],
  ["Pune Corporate Innova Car Hire", "Pune to Office Innova Cab"],
  ["Affordable Corporate Innova Service", "Corporate Car Hire Pune"],
  ["Corporate Business Travel with Innova", "Innova Cabs for Business Meetings"],
  ["Innova for Corporate Group Travel", "Pune to Corporate Event by Innova"],
  ["Book Corporate Innova for Executive Travel", "Luxury Corporate Travel in Innova"],
  ["Corporate Travel Package Innova Pune", ""]
],
"whychoose": [
  {
    "WhyChooseheading": "Reliable and On-Time Service",
    "WhyChoosedescription": "At S9 Travels, we understand the importance of punctuality in the corporate world. Whether it’s for an important business meeting, corporate event, or daily office commute, we ensure that our Innova cabs are on time to pick up and drop off your employees or clients. We take pride in our reliability and professionalism."
  },
  {
    "WhyChooseheading": "Comfortable and Spacious Vehicles",
    "WhyChoosedescription": "Our Toyota Innova cabs provide the ideal solution for corporate travel. With ample space for both passengers and luggage, air conditioning, and comfortable seating, our Innova vehicles ensure that your employees or guests have a smooth and relaxing ride, whether it’s for a short office commute or a long-distance trip."
  },
  {
    "WhyChooseheading": "Experienced and Professional Drivers",
    "WhyChoosedescription": "Our drivers are experienced, courteous, and professional, ensuring that your team or clients receive the highest standard of service. They are well-versed in corporate etiquette and take care of the comfort and safety of all passengers, offering a seamless travel experience."
  },
  {
    "WhyChooseheading": "Affordable and Transparent Pricing",
    "WhyChoosedescription": "S9 Travels offers competitive pricing for corporate cab services, with clear, upfront cost breakdowns. There are no hidden charges, and we ensure complete transparency in our pricing, so you can manage your corporate transportation budget with ease."
  },
  {
    "WhyChooseheading": "Safe and Comfortable Journey",
    "WhyChoosedescription": "Your employees or clients’ safety is our top priority. Our Toyota Innova vehicles are equipped with modern safety features such as airbags, seat belts, and GPS tracking to ensure a secure and comfortable ride. We make sure every journey, whether for work or leisure, is both safe and enjoyable."
  },
  {
    "WhyChooseheading": "24/7 Availability",
    "WhyChoosedescription": "We offer round-the-clock service for your corporate transportation needs. Whether it’s early morning airport pickups, late-night office returns, or transport for a corporate event, S9 Travels ensures that we’re available whenever you need us."
  },
  {
    "WhyChooseheading": "Hassle-Free Booking Process",
    "WhyChoosedescription": "Booking an Innova cab for corporate purposes is simple and efficient with S9 Travels. You can make a booking online via our website or mobile app, or our customer service team is available to assist with any special requirements or bulk bookings for corporate events or business trips."
  },
  {
    "WhyChooseheading": "Customized Corporate Travel Packages",
    "WhyChoosedescription": "We offer tailored solutions for corporate travel. Whether you need to arrange daily transport for employees, shuttle services for clients, or a luxury ride for executives, we can customize our services to meet your specific needs."
  }
]






















    }



    const faqData = [
        [
          {
            question: 'How can I book an Innova cab for corporate office travel with S9 Travels?',
            answer: 'You can easily book an Innova cab online via our website or mobile app. For bulk bookings or special requirements, feel free to contact our customer service team, and we’ll assist you in arranging the best service for your needs.',
          },
          {
            question: 'What is the seating capacity of the Innova cab?',
            answer: 'The Toyota Innova comfortably accommodates up to 6 passengers, making it ideal for transporting small to medium-sized corporate groups, executives, or clients.',
          },
          {
            question: 'Are the drivers professional and experienced for corporate travel?',
            answer: 'Yes, all our drivers are highly professional, experienced, and trained in corporate etiquette. They ensure a smooth and comfortable journey, prioritizing the safety and comfort of all passengers.',
          },
          {
            question: 'What payment options are available for corporate bookings?',
            answer: 'We offer flexible payment options for corporate clients, including cash, credit/debit cards, and online payments via our app. For larger corporate bookings, we can provide customized billing solutions.',
          },
          {
            question: 'Can I book an Innova cab for a round trip for corporate events?',
            answer: 'Yes, we can arrange round trips for corporate events, business meetings, or any other needs. Simply provide your return details, and we will ensure the trip is seamless and on time.',
          },
          {
            question: 'Are there any extra charges for waiting or detours during corporate travel?',
            answer: 'Any extra charges for waiting time or detours will be communicated to you beforehand, ensuring complete transparency in pricing.',
          },
          {
            question: 'Can I use the Innova cab for client meetings, events, or business travel?',
            answer: 'Yes, our Innova cabs are perfect for transporting clients to meetings, corporate events, or even for longer business trips. We ensure a comfortable and professional experience for all passengers.',
          },
          {
            question: 'What is the luggage allowance for an Innova cab?',
            answer: 'The Toyota Innova has ample space for standard luggage, making it suitable for transporting executives and their bags. If there are additional luggage or special requirements, please inform us when booking, and we will accommodate your needs.',
          },
          {
            question: 'Is S9 Travels available for group corporate travel?',
            answer: 'Yes, we provide Innova cabs for group corporate travel. Whether it’s a team outing, client meetings, or corporate retreats, we offer safe and comfortable transport for your group.',
          },
          {
            question: 'Why should I choose S9 Travels for my corporate Innova cab booking?',
            answer: 'S9 Travels offers reliable, comfortable, and professional corporate transportation services. Our well-maintained vehicles, experienced drivers, and transparent pricing make us the perfect choice for all your corporate travel needs.',
          },
        ]
      ];
      
      const testimonialsData = [
        {
          name: 'Mr. Rahul Sharma',
          designation: 'HR Manager',
          rating: [1, 1, 1, 1, 1],
          text: '“S9 Travels has been our go-to service for corporate transport. The Innova cabs are always well-maintained, and the drivers are professional and punctual. Our employees enjoy the comfortable ride to and from meetings. Highly recommend their services!”',
        },
        {
          name: 'Mrs. Priya Mehta',
          designation: 'Event Coordinator',
          rating: [1, 1, 1, 1, 1],
          text: '“We used S9 Travels for transporting clients to a corporate event, and it was a seamless experience. The driver was professional, and the vehicle was clean and spacious. We’ll definitely continue to book with S9 Travels for our future corporate events!”',
        },
      ];
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
    
    
    
    
    








    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 8850328441",
            "+91 9552526916",

        ],
        email: "booking@s9travels.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Book Pune To Nashik Cab",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Book Pune To Ganpatipule Cab",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Book Pune To Ratnagiri Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Book Pune To Devkund Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Book Pune To Goa Cab Taxi",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "Book Pune To Kolhapur Cab",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Book Pune To Lonavala Cab",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Book Pune To Alibaug Cab",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Book Pune To Aurangabad Cab",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Book Pune To Bhimashankar Cab",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Book Murud Janjira Cab From Pune",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Book Pune To Adlabs Imagica Cab",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Book Pune To Mahabaleshwar Cab",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Book Pune To Trimbakeshwar Cab",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Pune Mumbai Pune Round Trip",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " Mumbai Pune Pickup Drop",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Outstation Cabs From Pune",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Bus Service In Pune",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "12 Jyotirlinga Yatra From Pune",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Pune To Grishneshwar Cab Services",
        },
        
        {
            place: "/images/keyword/22.jpg",
            text: "Pune To Malshej Ghat Cab",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune To Pandharpur Cab Service",
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Pune To Panhala Fort Cab Service",
        },
        {
            place: "/images/keyword/25.jpg",
            text: " Pune To Raigad Fort Cab Service",
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Pune To Satara Kas Pathar Cab ",
        },
        {
            place: "/images/keyword/27.jpg",
            text: " Pune To Shirdi Cab Pickup Drop",
        },
    ];


    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];


   
    const productSchema = {
        "@context": "https://schema.org",
        "@type": "Product",
        "name": "Innova Cab for Corporate Office",
        "description": "Book an Innova cab for corporate office travel in Pune with S9 Travels. We offer luxury and affordable Innova cabs for office commutes, corporate events, business meetings, group travel, and executive travel. Convenient, reliable, and professional service for all corporate travel needs.",
        "aggregateRating": {
          "@type": "AggregateRating",
          "bestRating": "5",
          "worstRating": "1",
          "ratingValue": "4.8",
          "ratingCount": "1500"
        }
      };
      
      
      
      
      


    return (
        <div>
         <Helmet>
        <title>Innova Cab for Corporate Office | Book Corporate Innova for Business Travel in Pune | S9 Travels</title>
        <meta 
          name="description" 
          content="Book an Innova cab for corporate office travel in Pune. Affordable, luxury corporate Innova taxi service for business meetings, office commutes, and corporate events. Executive and group travel services for all corporate travel needs in Pune." 
        />
        
        {/* Inject JSON-LD Schema */}
        <script type="application/ld+json">
          {JSON.stringify(productSchema)}
        </script>
      </Helmet>
      
<section className="page-title centred">
      <div className="bg-layer" style={{ backgroundImage: 'url(/images/background/page-title.jpg)' }}></div>
      <div className="auto-container">
        <div className="content-box">
        
          <h1>{cardData.keyword}</h1>
        </div>
      </div>
    </section>

      

            <section id="about" className="jarallax text-light">
                <div className="center-y relative text-center">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                {/* <h1 className='text-white'>{cardData.keyword}</h1> */}
                            </div>
                            <div className="clearfix"></div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/37.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#322E77', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                  <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For S9 Travels</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                            <FAQKeyword  faqs={faqData} />

                                                {/* <FAQKeyword faqData={faqData} /> */}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <Testimonials testimonials={testimonialsData} />
                         

                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #252E5B',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#252E5B' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+918850328441" className="d-block  text-white">+91 8850328441</a>
                                                <a href="tel:+919552526916" className="d-block  text-white">+91 9552526916</a>
                                                


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#252E5B' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Email</h4>
                                                <a href="mailto:booking@s9travels.com" className=" text-white d-block">
                                                    booking@s9travels.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#252E5B' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> S9 Travels <br/>
                                                    Khandesh Nagar, Ghandharva Nagri, Moshi,Pune, pin-412105
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Innovacabforcorporateoffice;